import { TERMS_MAP, TERMS_I18N_MAP } from '@/utils/constants'

export const useTermsStore = defineStore('terms', () => {
  const nuxtApp = useNuxtApp()
  const authStore = useAuthStore()
  const { countryCodeOfGeoIP } = storeToRefs(authStore)

  const termsList = ref<TermsItemWithI18n[]>([])
  const termsMap = ref<TermsMap<CountryCodeOfGeoIP>>({})

  async function getTermsList() {
    try {
      const resp = await nuxtApp.$api.terms.getTermsList()
      if (resp?.data && Array.isArray(resp.data)) {
        const termsI18nMap = TERMS_I18N_MAP[countryCodeOfGeoIP.value]
        termsList.value = [
          ...resp.data.map((terms) => ({
            ...terms,
            name: termsI18nMap[terms.key as keyof typeof termsI18nMap]
          }))
        ]
      }
      setTermsMap()
    } catch (e) {
      console.log(e)
    }
  }

  async function getTermsInfo(termsKey: TermsKey<CountryCodeOfGeoIP>) {
    if (termsList.value?.length === 0 || !termsMap.value[termsKey]) {
      await getTermsList()
    }
    const fallbackTermsMap = TERMS_MAP[countryCodeOfGeoIP.value]
    const fallbackTermsData =
      fallbackTermsMap[termsKey as keyof typeof fallbackTermsMap]
    return termsMap.value[termsKey] || fallbackTermsData
  }

  function setTermsMap() {
    if (termsList.value?.length > 0) {
      termsMap.value = Object.fromEntries(
        termsList.value.map((item) => [
          item.key,
          {
            id: item.id,
            type: item.type
          }
        ])
      )
    } else {
      termsMap.value = TERMS_MAP[countryCodeOfGeoIP.value]
    }
  }

  return {
    termsList,
    termsMap,
    getTermsList,
    getTermsInfo
  }
})
